import { render, staticRenderFns } from "./GridLoadMore.vue?vue&type=template&id=c0fde9fa&"
import script from "./GridLoadMore.vue?vue&type=script&lang=js&"
export * from "./GridLoadMore.vue?vue&type=script&lang=js&"
import style0 from "./GridLoadMore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports